import React, { Component } from "react";
import PropTypes from "prop-types";
import {
  tr,
  th,
  td,
  thead,
  Table,
  div,
  tbody,
  Button,
  Alert,
  FormGroup,
  FormControl,
  InputGroup,
  Glyphicon,
  DropdownButton,
  MenuItem,
  ButtonGroup,
  ControlLabel
} from "react-bootstrap";
import { NewBreadcrumb as BreadcrumbComponent } from "../../../components";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { createBrowserHistory } from "history";
import { withRouter, Link } from "react-router-dom";
import {
  get_user_list
} from "../../../redux/actions/subAdminActions";
import { Notification } from "../../../components/notifications";
import isEmpty from "lodash.isempty";
import Pagination from "react-paginating";
import "../../../style/react-paginating.css";
import Dialog from "react-bootstrap-dialog";
import { renderAlert, clearAlert } from "../../../redux/actions/alertsActions";
import "../../../style/listPage.scss";
import DatePicker from "react-date-picker";
import {aclUtil} from "../../util"

const history = createBrowserHistory();
class CustomerList extends Component {
  static contextTypes = {
    router: PropTypes.object
  }
  constructor(props) {
    super(props);
    this.state = {
      userList: [],
      menuKey: 'CUSTOMER_LIST',
      limit: 25,
      userTypeID: 4,
      totalRecords: 0,
      perPage: 0,
      currentPage: 1,
      pageCount: 0,
      alertMessage: "",
      msgType: "success",
      path: ["Home", "Customer List"],
      links:["home", "customerList"],
      show: false,
      emailSortIcon: "",
      firstNameSortIcon: "",
      lastNameSortIcon: "",
      userNameSortIcon: "",
      direction: "",
      orderBy: "",
      searchString: "",
      search: "",
      userID: '',
      method: '',
      reason: '',
    };
    this.handleDismiss = this.handleDismiss.bind(this);
    this.handleShow = this.handleShow.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }


  handleSort = orderBy => e => {
    e.preventDefault();
    let direction;
    const sortIcon = `${orderBy}SortIcon`;
    if (this.state.direction === "") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "ASC") {
      direction = "DESC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-down",
        direction: "DESC",
        orderBy: orderBy
      });
    } else if (this.state.direction === "DESC") {
      direction = "ASC";
      this.setState({
        [sortIcon]: "glyphicon glyphicon-chevron-up",
        direction: "ASC",
        orderBy: orderBy
      });
    }
    let formData = { orderBy: orderBy, direction: direction,limit: this.state.limit, userTypeID: this.state.userTypeID };
    
    this.props.get_user_list(formData);
  };

  handleSearch = () => e => {
    const searchString = e.target.value;
    let formData = { page: 1,limit: this.state.limit, userTypeID: this.state.userTypeID };

    if (searchString.length > 0) {
      formData.search = searchString;
    }
    if(this.props.match && this.props.match.params && this.props.match.params.userID){
      formData.userID = this.props.match.params.userID;
    }
    this.props.get_user_list(formData);
    this.setState({ searchString: searchString });
  };

  handleDismiss() {
    this.setState({ show: false });
  }

  handleShow() {
    this.setState({ show: true });
  }

  componentDidMount() {
    this.handleDismiss();
    this.props.clearAlert();
    let formData = { page: this.state.currentPage,limit: this.state.limit, userTypeID: this.state.userTypeID };
    this.props.get_user_list(formData);
  }
  handlePageChange = page => {
    this.setState({
      currentPage: page
    });
    let formData = { page: page,limit: this.state.limit, userTypeID: this.state.userTypeID };
    if (this.state.direction !== "" && this.state.orderBy !== "") {
      formData.orderBy = this.state.orderBy;
      formData.direction = this.state.direction;
    } else if (this.state.searchString !== "") {
      formData.search = this.state.searchString;
    }
    this.props.get_user_list(formData);
  };

  componentWillReceiveProps(nextProps) {
    if(!aclUtil.isPrimaryMenuAccessible(this.state.menuKey)){
      this.context.router.history.push("/restrictedAccess");
    }

    if (this.props.userList !== nextProps.userList) {
      if (nextProps.userList) {
        const setPageCount =
          nextProps.userList.total / nextProps.userList.per_page;
        this.setState({
          userList: nextProps.userList.data,
          totalRecords: nextProps.userList.total,
          perPage: nextProps.userList.per_page,
          pageCount: setPageCount
        });
      }
    }

   
    if (this.props.error !== nextProps.error) {
      if (nextProps.error) {
        this.setState({ alert: false });
        this.props.clearAlert();
        this.handleShow();
        this.props.renderAlert("warning", nextProps.error);
      }
    }

    if (nextProps.message) {
      this.setState({
        alertMessage: nextProps.message,
        msgType: nextProps.alertType
      });
    }
  }

  render() {
    const { path } = this.state;
    const { currentPage, totalRecords, perPage, pageCount } = this.state;
    let userRow;
    if (!isEmpty(this.props.userList)) {
      userRow = this.props.userList.data.map((user, index) => (
        <tr key={user.user_id}>
          <td>{user.firstName}</td>
          <td>{user.lastName}</td>
          <td>{user.userName}</td>
          <td>{user.email}</td>
          <td>{user.status}</td>
          <td>
            <ButtonGroup key={'btn'+user.user_id}>
              <DropdownButton title="Action" id="bg-nested-dropdown">
                {aclUtil.checkACL('DASHBOARD') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/addSubAdmin/${user.user_id}`)}><i className="glyphicon glyphicon-pencil"></i> Edit Details</MenuItem>) : ("")}
                {aclUtil.checkACL('LIST_VOUCHERS') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/voucherList/${user.user_id}`)}><i className="glyphicon glyphicon-eye-open"></i> Offers Purchased</MenuItem>) : ("")}
                {aclUtil.checkACL('ORDERS') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/orders/${user.user_id}`)}><i className="glyphicon glyphicon-eye-open"></i> Order History</MenuItem>) : ("")}
                {aclUtil.checkACL('ADD_REMOVE_STORE_CREDIT') ? (<MenuItem eventKey={Math.random()} onClick={() => this.context.router.history.push(`/store-credit-preview/${user.user_id}`)}><i className="glyphicon glyphicon-eye-open"></i> Credits</MenuItem>) : ("")}
              </DropdownButton>
            </ButtonGroup>
          </td>
        </tr>
      ));
    }
    if (!isEmpty(this.props.userList) && this.props.userList.data.length == 0) {
      userRow = <tr >
          <td colSpan="6" style={{textAlign: 'center'}}><b>No Record Found .. </b></td>
        </tr>
    }
    return (
      <div>
        <Dialog
          ref={el => {
            this.dialog = el;
          }}
        />
        <div className="col-lg-12 user-list list-page">
          <div className="row">
            <div className="col-xs-12">
              <BreadcrumbComponent path={this.state.path} links={this.state.links} context={this.context}/>
            </div>
          </div>
          <div className="panel">
            <header className="panel-heading">
              <div className="row">
                <div className="col-lg-8 col-md-4 col-sm-12">
                  <h4>Customer List</h4>
                </div>
                <div className="col-lg-4 col-md-4 col-sm-12">
                  <FormGroup>
                    <InputGroup>
                      <FormControl type="text" onKeyUp={this.handleSearch()} />
                      <InputGroup.Addon>
                        <Glyphicon glyph="glyphicon glyphicon-search" />
                      </InputGroup.Addon>
                    </InputGroup>
                  </FormGroup>
                </div>
              </div>
            </header>
            <div className="panel-body">
              {this.state.show &&
                this.state.alertMessage !== "" && (
                  <div className="col-lg-12">
                    <Alert
                      bsStyle={this.state.msgType}
                      onDismiss={this.handleDismiss}
                    >
                      <strong>{this.state.msgType}:</strong>{" "}
                      {this.state.alertMessage}
                    </Alert>
                  </div>
                )}
              <div className="col-lg-12">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      <th onClick={this.handleSort("firstName")}>
                        First Name<span
                          className={this.state.firstNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("lastName")}>
                        Last Name<span
                          className={this.state.lastNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("userName")}>
                        User Name<span
                          className={this.state.userNameSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th onClick={this.handleSort("email")}>
                        Email<span
                          className={this.state.emailSortIcon}
                          aria-hidden="true"
                        />
                      </th>
                      <th>Status</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>{userRow}</tbody>
                </table>

                <div className="text-center">
                  <Pagination
                    total={totalRecords}
                    limit={perPage}
                    pageCount={5}
                    currentPage={currentPage}
                  >
                    {({
                      pages,
                      currentPage,
                      hasNextPage,
                      hasPreviousPage,
                      previousPage,
                      nextPage,
                      totalPages,
                      getPageItemProps
                    }) => (
                      <div className="pagination">
                        <button className="btn btn-default"
                          {...getPageItemProps({
                            pageValue: 1,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          first
                        </button>

                        {hasPreviousPage && (
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: previousPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {"<"}
                          </button>
                        )}

                        {pages.map(page => {
                          let activePage = null;
                          if (currentPage === page) {
                            activePage = {
                              backgroundColor: "#ccc",
                              color: "#666"
                            };
                          }
                          return (
                            <button className="btn btn-default"
                              key={page}
                              style={activePage}
                              {...getPageItemProps({
                                pageValue: page,
                                onPageChange: this.handlePageChange
                              })}
                            >
                              {page}
                            </button>
                          );
                        })}

                        {hasNextPage && (
                          <button className="btn btn-default"
                            {...getPageItemProps({
                              pageValue: nextPage,
                              onPageChange: this.handlePageChange
                            })}
                          >
                            {">"}
                          </button>
                        )}

                        <button className="btn btn-default"
                          {...getPageItemProps({
                            pageValue: totalPages,
                            onPageChange: this.handlePageChange
                          })}
                        >
                          last
                        </button>
                      </div>
                    )}
                  </Pagination>
                </div>
              </div>
              <div className="clearfix" />
            </div>
          </div>
        </div>
      </div>
    );
  }
}

CustomerList.propTypes = {
  get_user_list: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  userList: state.subAdminReducer.userList,
  error: state.subAdminReducer.error,
  alertType: state.alertsReducer.alertType,
  message: state.alertsReducer.message
});

export default connect(mapStateToProps, {
  get_user_list,
  renderAlert,
  clearAlert,
})(CustomerList);



// WEBPACK FOOTER //
// ./src/app/views/admin/subAdmin/customerList.js